module.exports = __webpack_public_path__ + "static/img/app-slide-show5.2be436e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-tb-wgm/images/app-slide-show5.png
// module id = SWau
// module chunks = 44